export default __webpack_public_path__ + "static/media/explore-tablet-6.0168207b.png";